import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: 'textarea[autoResize]',
    standalone: false
})
export class AutoResizeDirective {
  constructor(private element: ElementRef<HTMLTextAreaElement>) {}

  /**
   * Returns the true single row height using a hidden clone for accuracy.
   * Copies all computed styles from the original textarea.
   */
  private getAccurateSingleRowHeight(): number {
    const textarea = this.element.nativeElement;
    const clone = document.createElement('textarea');
    // Copy all computed styles
    const computed = window.getComputedStyle(textarea);
    for (let i = 0; i < computed.length; i++) {
      const key = computed.item(i);
      if (key) {
        clone.style.setProperty(key, computed.getPropertyValue(key));
      }
    }
    clone.value = '';
    clone.rows = 1;
    clone.style.height = 'auto';
    clone.style.visibility = 'hidden';
    clone.style.position = 'absolute';
    clone.style.zIndex = '-1000';
    clone.style.top = '0';
    clone.style.left = '0';
    clone.style.pointerEvents = 'none';
    textarea.parentNode?.appendChild(clone);
    const height = clone.scrollHeight;
    textarea.parentNode?.removeChild(clone);
    return height;
  }

  @HostListener('input')
  onInput(): void {
    const textarea = this.element.nativeElement;
    textarea.style.height = 'auto';
    let newHeight: number;
    if (!textarea.value) {
      textarea.style.height = newHeight + 'px';
    } else {
      newHeight = textarea.scrollHeight;
      textarea.style.height = newHeight + 'px';
    }
  }

  @HostListener('focus')
  @HostListener('blur')
  onFocusOrBlur(): void {
    this.onInput();
  }

  ngAfterViewInit() {
    // Initial resize in case there is pre-filled text
    this.onInput();
  }

  /**
   * Resets the textarea height to its minimum (single row) height using accurate measurement.
   * Can be called from parent component after clearing input.
   */
  resetHeight(): void {
    const textarea = this.element.nativeElement;
    textarea.value = '';
    textarea.style.height = 'auto';
    const minHeight = this.getAccurateSingleRowHeight();
    textarea.style.height = minHeight + 'px';
    // Optionally, reset #messages padding-bottom
    const messages = document.getElementById('messages');
  }
}
